module.exports = __webpack_public_path__ + "img/oman.53cc3d3.webp";